/**
 * 表格/列表单元格截断时的原生 title：空值与占位符不挂 title。
 * 可与 AutoEllipsisTitle 全局自动补全配合使用。
 * @param {...unknown} parts
 * @returns {string|undefined}
 */
export function cellDisplayTitle(...parts) {
  const text = parts
    .map((part) => {
      if (part == null) return '';
      if (typeof part === 'string' || typeof part === 'number') return String(part).trim();
      return '';
    })
    .filter(Boolean)
    .join(' · ');
  if (!text || text === '—' || text === '-') return undefined;
  return text;
}
